import { AppBar, Toolbar, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		btn: {
			paddingLeft: 0,
		},
		form: {
			margin: 'auto',
			maxWidth: 700,
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(4),
		},
		title: {
			fontSize: 14,
			marginBottom: 16,
		},
	});

/**
 * パスワード変更完了画面
 */
class PasswordChangeEnd extends React.Component<IProps> {
	public constructor(props: IProps) {
		super(props);
	}

	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<AppBar className={this.props.classes.appBar}>
					<Toolbar>
						<Typography variant="h6" color="inherit">
							{i18n.t('PwrPasswordChangeEnd_0001')}
						</Typography>
					</Toolbar>
				</AppBar>
				<Paper>
					<div className={classes.form}>
						<Typography>
							{i18n.t('PwrPasswordChangeEnd_0002')}
						</Typography>
						<Link to={Routes.getPath(Screens.LOGIN)}>
							<Button className={classes.btn} color="primary">
								{i18n.t('PwrPasswordChangeEnd_0003')}
							</Button>
						</Link>
					</div>
				</Paper>
			</div>
		);
	}
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

// tslint:disable-next-line: no-empty-interface
export interface IPasswordChangeEndProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IPasswordChangeEndProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(PasswordChangeEnd);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/PwrPasswordChangeEnd.tsx